import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Router from 'vue-router'
import Route from 'vue-router'
import store from '@/store'
Vue.use(VueRouter)
// 解决路由重复导航报错问题
// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const routes = [
    // 登录
    {
        path: '/',
        name: 'login',
        component: () => import('@/views/login.vue'),

    },
    {
        path: '/application',
        name: 'Application',
        component: () => import('@/views/application/index.vue'),

    },
    // ChatLibrary
    {
        path: '/home',
        name: 'Home',
        component: Home,
        meta: {
            rules: '1'
        }
    },
    // ChatLanguage
    {
        path: '/chatResearch',
        name: 'ChatResearch',
        component: () => import('@/views/ChatResearch/ChatResearch.vue'),
        meta: {
            rules: '2'
        }
    },
    // ChatFellows
    {
        path: '/chatCQUSci',
        name: 'ChatCQUSci',
        component: () => import('@/views/ChatCQU_Sci/ChatCQU_Sci.vue'),
        meta: {
            rules: '3'
        }
    },
    {
        path: '/chatNewResearch',
        name: 'chatNewResearch',
        component: () => import('@/views/chatNewResearch/chatNewResearch.vue'),
        meta: {
            rules: '4'
        }
    },

    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/views/chatNewResearch/dashboard.vue'),
        meta: {
            rules: '4'
        }
    },
    {
        path: '/chatOpenResearch',
        name: 'chatOpenResearch',
        component: () => import('@/views/chatOpen/chatOpen.vue'),
        meta: {
            rules: '4'
        }
    },
    {
        path: '/ChatOpen',
        name: 'ChatOpen',
        component: () => import('@/views/chatOpen/index.vue'),
        meta: {
            rules: '4'
        }
    },
    {
        path: '/ChatDocuments',
        name: 'ChatDocuments',
        component: () => import('@/views/ChatDocuments/index.vue'),
        meta: {
            rules: '5'
        }
    },

    {
        path: '/upload',
        name: 'upload',
        component: () => import('@/views/ChatDocuments/upload.vue'),
        meta: {
            rules: '5'
        }
    },
    {
        path: '/ChatData',
        name: 'ChatData',
        component: () => import('@/views/ChatData/index.vue'),
        meta: {
            rules: '5'
        }
    },
    {
        path: '/uploadData',
        name: 'uploadData',
        component: () => import('@/views/ChatData/upload.vue'),
        meta: {
            rules: '5'
        }
    },
    {
        path: '/journals',
        name: 'journals',
        component: () => import('@/views/journals/journals.vue'),
        meta: {
            rules: '6'
        }
    },
    {
        path: '/chatArchives',
        name: 'chatArchives',
        component: () => import('@/views/chatArchives/chatArchives.vue'),
        meta: {
            rules: '7'
        }
    },
    {
        path: '/chatArchivesList',
        name: 'chatArchivesList',
        component: () => import('@/views/chatArchives/chatArchivesList.vue'),
        meta: {
            rules: '7'
        }
    },

    {
        path: '/archivesDetail',
        name: 'archivesDetail',
        component: () => import('@/views/chatArchives/archivesDetail.vue'),
        meta: {
            rules: '7'
        }
    },
    {
        path: '/ChatBooks',
        name: 'ChatBooks',
        component: () => import('@/views/ChatBooks/ChatBooks.vue'),
        meta: {
            rules: '9'
        }
    },
    //   新知chatresearch
    {
        path: '/knowledgeResearch',
        name: 'knowledgeResearch',
        component: () => import('@/views/knowledgeResearch/knowledgeResearch.vue'),
        meta: {
            rules: '11'
        }
    },
    {
        path: '/mathphys',
        name: 'mathphys',
        component: () => import('@/views/mathphys/mathphys.vue'),
        
    },
    {
        path: '/mathphysDetail',
        name: 'mathphysDetail',
        component: () => import('@/views/mathphys/mathphysDetail.vue'),
        
    }
    


]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})


router.beforeEach((to, from, next) => {
    if (to.path === '/application' || to.path === '/mathphys' || to.path === '/mathphysDetail') {
        return next()
    } else {
        if (to.query.type && to.query.type === 'knowledge') {
            return next()
        } else {
            if (to.path === '/' && !store.getCookie("Chat_token")) {
                next()
            } else if (to.path !== '/' && !store.getCookie("Chat_token")) {
                return next('/')
            } else if (to.path !== '/home' && store.getCookie("Chat_token")) {

                return next()
            } else {
                next()
            }
        }
    }



})
export default router